import React, {createContext, useContext, useReducer} from "react";
import {VaprDeviceOverviewReducer} from "../reducer/VaprDeviceOverviewReducer";
import {PermissionsContext} from "../../../permissions/PermissionsContext";
import PermissionAlertBanner from "../../../commonui/PermissionAlertBanner";

export const VaprDeviceOverviewContext = createContext();

const VaprDeviceOverviewContextProvider = (props) => {
    const data = {
        sortPref: {column: "name", direction: "ascending"},
        vaprDeviceInformation: {},
        macAddressArray: [],
        loadingOverview: true
    }
    const [viewModel, dispatch] = useReducer(VaprDeviceOverviewReducer, data)
    const {isAuthorised} = useContext(PermissionsContext);

    if (!isAuthorised) {
        return (
            <PermissionAlertBanner/>
        );
    }
    return (
        <VaprDeviceOverviewContext.Provider value={{viewModel, dispatch}}>
            {props.children}
        </VaprDeviceOverviewContext.Provider>
    )
}

export default VaprDeviceOverviewContextProvider



// WEBPACK FOOTER //
// ./src/components/devicemanagement/vaprdevice/context/VaprDeviceOverviewContext.js